/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import BoardRanges from 'solis/logic/board/ranges';


export const GalaxyParent = (application) =>
{
  return application.getGalaxy();
};


export const AccountParent = (application, { account }) =>
{
  return application.getGalaxy().getAccount(account);
};


export const ColonyParent = (application, { colony }) =>
{
  return application.getGalaxy().getColony(colony);
};


export const BoardParent = (application, { board }) =>
{
  const entity = application.getGalaxy().getBoard(board);

  return { entity, logic: new BoardRanges(entity) };
};
